























import {
  Vue, Component, Prop, Watch, PropSync,
} from 'vue-property-decorator';
import {
  PartnersApi, DocumentRequest, UserApi, User, Partner,
} from '@compassdigital/foodworks.ts.sdk';
import Textfield from '@/components/Form/Textfield/index.vue';
import CommonWorkingDay from '@/components/Form/NonWorkingDays/CommonWorkingDay/index.vue';

@Component({
  components: {
    Textfield,
    CommonWorkingDay,
  },
})
export default class NonWorkignEditDays extends Vue {
  @PropSync('eventInformation', {}) eventInfoLocal: any;

  @Prop() updatedDate!: any;

  @Prop() isNew!: boolean;

  @Prop() saving!: boolean;

  @Prop() loading!: boolean;

  public onClose() {
    this.$emit('close');
  }

  public onSave() {
    this.$emit('onSaveEvent');
  }
}
